/**
 * Convert a string with Latin-script diacritics or extended Latin characters
 * to its plain ASCII Latin equivalent.
 *
 * Examples:
 *   `Curaçao`  → `Curacao`
 *   `Türkiye`  → `Turkiye`
 *   `Łódź`     → `Lodz`
 *   `Côte d'Ivoire` → `Cote d'Ivoire`
 *
 * Uses the `latinize` library which handles both combining diacritics
 * (e.g. `ç`, `é`) and non-decomposable extended Latin glyphs (e.g. `Ł`,
 * `Ø`, `Æ`, `ß`) via an explicit lookup table.
 */

import latinizeLib from 'latinize';

/**
 * Transliterate a Latin-script string to plain ASCII.
 *
 * @param {string | null | undefined} str
 * @returns {string} Latinized string, or an empty string if `str` is falsy.
 */
const latinize = (str) => (str ? latinizeLib(str) : '');

export default latinize;
